var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12"},[_c('h1',{attrs:{"data-testid":"afk-heading__title"}},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{attrs:{"data-testid":"afk-heading__subtitle"}},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }